import React from 'react';
import classes from './SmallPostsView.module.css';

/* eslint-disable max-len */

const smallPostsView = (props) => {
  return (
    <svg
      className={classes.SVGContainer}
      xmlns="http://www.w3.org/2000/svg"
      id="Component_1066"
      width="19.059"
      height="19.059"
      viewBox="0 0 19.059 19.059"
      stroke={props.fillColor ? props.fillColor : '#36a1da'}
    >
      <g id="Group_7186" opacity="0.001">
        <path
          id="Path_3873"
          fill={props.fillColor ? props.fillColor : '#36a1da'}
          d="M2.042 0h14.975a2.042 2.042 0 0 1 2.042 2.042v14.975a2.042 2.042 0 0 1-2.042 2.042H2.042A2.042 2.042 0 0 1 0 17.017V2.042A2.042 2.042 0 0 1 2.042 0z"
        />
      </g>
      <rect
        id="Rectangle_5831"
        width="5"
        height="4"
        fill={props.fillColor ? props.fillColor : '#36a1da'}
        rx="1"
        transform="translate(2.529 12.529)"
      />
      <path id="Line_1070" d="M0 0L5.917 0" transform="translate(8.508 15.996)" />
      <path id="Line_1069" d="M0 0L7.737 0" transform="translate(8.508 14.634)" />
    </svg>
  );
};

export default smallPostsView;
